<template>
    <div>
       <HeaderTeam header="ตารางการทำงาน" :img_header="header_image" link_back="team"/>
       <MenuTeamWorkScheduleList/>
       <WorkScheduleList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/schedule_1.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamWorkScheduleList from '@/components/menuadmin/team/teamworkschedule/MenuTeamWorkScheduleList.vue'
import WorkScheduleList from '@/components/menuadmin/team/teamworkschedule/WorkScheduleList.vue'
export default {
    name:'workSchedule',
    components:{
        HeaderTeam,
        MenuTeamWorkScheduleList,
        WorkScheduleList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>